module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-form-item",
    class: {
      'is-error': _vm.error !== '',
        'is-validating': _vm.validating,
        'is-required': _vm.isRequired || _vm.required
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "zk-form-item__label",
    style: (_vm.labelStyle)
  }, [_vm._v("\n    " + _vm._s(_vm.label + _vm.form.labelSuffix) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zk-form-item__content",
    style: (_vm.contentStyle)
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "md-fade-bottom"
    }
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "zk-form-item__error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-2230ae91"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/form/src/form-item.vue
// module id = 241
// module chunks = 0